<template>
  <nav class="user-sidenav">
    <a
      v-for="item in sections"
      :key="item.id"
      :href="`#${item.id}`"
      data-scroll
      class="user-sidenav__item"
    >
      <i class="material-icons-round user-sidenav__icon">{{ item.icon }}</i>
      <span class="user-sidenav__label">{{ item.label }}</span>
    </a>
  </nav>
</template>

<script>
export default {
  name: "SideNav",
  props: {
    sections: {
      type: Array,
      default: () => [
        { id: 'basic-info', icon: 'receipt_long', label: '기본 정보' },
        { id: 'password', icon: 'lock', label: '비밀번호 변경' },
        { id: 'account-status', icon: 'verified_user', label: '계정 상태' },
      ],
    },
    itemSpacing: { type: Boolean, default: true },
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/scss/pineapple";

.user-sidenav {
  background: $p-panel;
  border: 1px solid $p-line;
  border-radius: $p-radius-lg;
  padding: 8px;
  position: sticky;
  top: 76px;
  display: flex;
  flex-direction: column;
  gap: 2px;

  &__item {
    display: flex;
    align-items: center;
    gap: 10px;
    padding: 10px 12px;
    border-radius: $p-radius;
    color: $p-ink2;
    text-decoration: none;
    font-size: 13px;
    font-weight: 600;
    transition: background $p-dur $p-ease, color $p-dur $p-ease;

    &:hover,
    &.active {
      background: $p-panel-alt;
      color: $p-ink;
    }
  }

  &__icon {
    font-size: 18px !important;
    color: $p-point-deep;
  }
}
</style>
